import { useCallback, useEffect, useRef, useState } from "react"
import { classroomObjectType } from "./AdminStudentsClassroom"
import TabsContentHeader from "../../components/AdminDashboardTabsContentHeader/TabsContentHeader"
import { formatClassroomStudentsCount, getScreenDimensions } from "../../utils/helper"
import images from "../../assets/images"
import { debounce } from "lodash"
import './AdminStudents.scss';
import { Checkbox, Tooltip } from "@mui/material"
import { useLazyQuery } from "@apollo/client"
import { GET_STUDENTS_BY_CLASSROOM } from "./api/AdminStudentsQuery"
import Loader from "../../components/Loader/Loader"
import ToasterWithMessage from "../../components/toaster"
import SwitchClassPopup from "../../components/SwitchClassPopup/SwitchClassPopup"
import EditStudentProfile from "./EditStudentProfile"
import MobileHeader from "../../components/MobileHeader/MobileHeader"
import { useDispatch } from "react-redux"
import { setHideScrollToTopButton } from "../../redux/slices/authSlice"
import { FETCH_POLICY } from "../../utils/constants"
interface AdminStudentPropsType {
    setDisplayStudents: (val: boolean) => void;
    displayStudents: boolean
    selectedClass: classroomObjectType | undefined
    isFullView: boolean;
    setisFullView: (value: boolean) => void;
    setisSearchClick: (value: boolean) => void;
    isSearchClick: boolean;
}

export interface Students {
    sId: string;
    sAvatarUrl: string;
    userByUId: {
        uFullName: string;
        uEmailId: string;
        uPhoneNumber: string;
        uUserName: string;
        uUserPassword: string;
    }
}

interface StudentsType {
    nodes: Students[],
    totalCount: number
}

const AdminStudents = ({ setDisplayStudents, displayStudents, selectedClass, isFullView, setisFullView, setisSearchClick, isSearchClick }: AdminStudentPropsType) => {
    const { backArrow, User, studentCheckboxChecked, studentCheckboxOutline, userImage, searchCloseIcon } = images;
    const [searchValue, setSearchValue] = useState("");
    const [displayStudentForm, setDisplayStudentForm] = useState<boolean>(false);
    const [studentsList,setStudentsList] = useState<StudentsType>();
    const [checkedStudents, setCheckedStudents] = useState<string[]>([]);
    const { error } = ToasterWithMessage();
    const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
    const [openSwitchClassPopup, setOpenSwitchClassPopup] = useState(false);
    const [refetch, setRefetch] = useState<boolean>(false);
    const [studentData, setStudentData] = useState<Students>();
    const baseUrl = process.env.REACT_APP_FRONTEND_URL;
    const studentNameRef = useRef<(HTMLDivElement | null)[]>([]);
    const [visibleTooltips, setVisibleTooltips] = useState<boolean[]>([]);
    const { isMobileScreen } = getScreenDimensions();
    const dispatch = useDispatch();

    const [getStudentsByClass, { loading }] = useLazyQuery(GET_STUDENTS_BY_CLASSROOM, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            setStudentsList(data?.allStudents);
            // setCheckedStudents([]);
            setIsSelectAllChecked(checkedStudents?.length > 0 ? data?.allStudents?.length === checkedStudents?.length : false);
        },
        onError: (err) => {
            error(err?.message);
        }
    });

    useEffect(() => {
        if (selectedClass) {
            getStudentsByClass({
                variables: {
                    cId: selectedClass?.cId,
                    searchInput: `%${searchValue.trim()}%`
                }
            })
        }
    },[selectedClass, refetch, displayStudentForm])

    useEffect(() => {
        if (!openSwitchClassPopup) {
            setCheckedStudents([]);
            setIsSelectAllChecked(false);
        }
    }, [openSwitchClassPopup])

    //To search students
    const handleSearchDebounce = useCallback(
        debounce((value) => {
            setSearchValue(value);
            if(value?.trim().length >= 3 || value.trim() === "") {
            getStudentsByClass({
                variables: {
                    cId: selectedClass?.cId,
                    searchInput: `%${value.trim()}%`
                }
            });
            }
        }, 500),
        [getStudentsByClass]
    );

    const handleCheckboxChange = (studentId: string) => {
        setOpenSwitchClassPopup(false);
        setCheckedStudents((prevState) => {
          const newCheckedStudents = prevState.includes(studentId)
            ? prevState.filter((id) => id !== studentId)
            : [...prevState, studentId];
          setIsSelectAllChecked(newCheckedStudents.length === studentsList?.nodes.length);
          return newCheckedStudents;
        });
      };  

      const handleCheckAll = () => {
        setOpenSwitchClassPopup(false);
        if (isSelectAllChecked) {
          setCheckedStudents([]);
        } else {
          setCheckedStudents(studentsList?.nodes.map((student) => student.sId) || []);
        }
        setIsSelectAllChecked(!isSelectAllChecked);
      };

    const handleClick = (data: Students) => {
        setDisplayStudentForm(true);
        setStudentData(data);
        setCheckedStudents([]);
        setIsSelectAllChecked(false);
    }

    const handleMouseEnter = (index: number) => {
        const ref = studentNameRef.current[index];
      
        if (ref) {
          const isOverflowing = ref.scrollWidth > ref.clientWidth;
          setVisibleTooltips((prev) => {
            const updated = [...prev];
            updated[index] = isOverflowing;
            return updated;
          });
        }
    };

    const handleMouseLeave = (index: number) => {
    setVisibleTooltips((prev) => {
        const updated = [...prev];
        updated[index] = false;
        return updated;
    });
    };

    const handleBackClick = () => {
        setDisplayStudents(false);
    }

    const handleCloseSearch = () => {
        setisSearchClick(false);
        setSearchValue("");
        handleSearchDebounce("");
    };

    const searchOnChange = (event: { target: { value: string; }; }) => {
        setSearchValue(event.target.value);
        if (handleSearchDebounce){
          handleSearchDebounce(event?.target?.value);
        }
    };

    const handleSearchClick = () => {
        setisSearchClick(true);
    }

    useEffect(() => {
        dispatch(setHideScrollToTopButton({hideScrollToTopButton: !displayStudentForm}));
    }, [displayStudentForm])

    return (
        <>
            {(!displayStudentForm) ? (
                <div className="AdminStudent">
                    {
                        (isMobileScreen && isSearchClick) ?
                        <div className={'adminStudentSearch'}>
                                <input id="searchBox" type='text' placeholder='Search' onChange={searchOnChange} value={searchValue} className='SearchInputFieldStyle' />
                                {(isMobileScreen && isSearchClick) && <img src={searchCloseIcon} alt='closeIcon' className='closeIcon' onClick={handleCloseSearch} />}
                        </div>
                        :
                        <>
                            <div className="studentMobileHeaderContainer">
                                <div className="studentMobileHeaderRightContainer">
                                    <img src={backArrow} className="backArrow" onClick={handleBackClick}/>
                                    <div className="mobileHeaderTitleTextStyle">Students</div>
                                </div>
                                <MobileHeader handleSearchClick={handleSearchClick}/>
                            </div>
                            <TabsContentHeader
                                title={selectedClass?.cOriginalName ? selectedClass?.cOriginalName : '-'}
                                subtitle={formatClassroomStudentsCount(studentsList?.totalCount || 0)}
                                addLabel={""}
                                setDisplayForm={setDisplayStudents}
                                displayForm={displayStudents}
                                subImage={isMobileScreen ? userImage : backArrow}
                                handleSearchDebounce={handleSearchDebounce}
                                searchValue={searchValue}
                                setSearchValue={setSearchValue}
                                tab={"student"}
                                handleCheckAll={handleCheckAll}
                                isSelectAllChecked={isSelectAllChecked}
                                setOpenSwitchClassPopup={setOpenSwitchClassPopup}
                                checkedStudents={checkedStudents}
                            />
                        </>
                    }
                    <div className="studentListOuterContainer">
                        { (loading || !studentsList ) ? <Loader /> : (
                        <div className={`${studentsList && studentsList?.totalCount > 0 ? 'studentListContainer' : 'forNoDataFound'}`}>
                            {
                                studentsList?.totalCount ?
                                    studentsList?.nodes?.map((student: Students, index: number) => {
                                        return (
                                            <div className="studentCardMainContainer">
                                                <div className="studentCheckBox">
                                                    <Checkbox
                                                        icon={<img src={studentCheckboxOutline} alt="Unchecked" height={14} width={14} />}
                                                        checkedIcon={<img src={studentCheckboxChecked} alt="Checked" height={13} width={13} />}
                                                        checked={checkedStudents.includes(student.sId)}
                                                        onChange={() => handleCheckboxChange(student.sId)}
                                                        style={{
                                                            backgroundColor: checkedStudents.includes(student.sId) ? "var(--color-steelblue)" : "transparent"
                                                        }}
                                                    />
                                                </div>
                                                <div className='studentCardContainer' key={`${index}-${student?.sId}`} onClick={() => handleClick(student)}>
                                                    <div className="studentImageCtn">
                                                        <img src={ student?.sAvatarUrl ? baseUrl + student?.sAvatarUrl : User} alt="studentImage" className={student?.sAvatarUrl ? "studentImg" : "studentImgDefault"} />
                                                    </div>
                                                    <Tooltip
                                                        title={student?.userByUId?.uFullName}
                                                        open={visibleTooltips[index] || false}
                                                        placement="bottom"
                                                        disableInteractive
                                                    >
                                                        <div className="studentName" ref={(el) => ( studentNameRef.current[index] = el)} onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={() => handleMouseLeave(index)}>
                                                        {student?.userByUId?.uFullName}
                                                        </div>
                                                    </Tooltip>
                                                </div>
                                            </div>
                                        )
                                    })
                                    :
                                    <div className='noDataFoundStyle'>No data found</div>
                            }
                        </div>
                        )}
                    </div>
                    <SwitchClassPopup 
                        open={checkedStudents.length > 0 && openSwitchClassPopup} 
                        setOpen={setOpenSwitchClassPopup}
                        selectedClass={selectedClass} 
                        checkedStudents={checkedStudents}
                        setRefetch={setRefetch}
                        refetch={refetch}
                    />
                </div>
            ) : (
                <EditStudentProfile 
                    displayStudentForm={displayStudentForm} 
                    setDisplayStudentForm={setDisplayStudentForm} 
                    studentData={studentData}                   
                />
            )}
        </>
    )
}
export default AdminStudents;
